.metricValue {
  display: flex;
  gap: 4px;
  align-items: center;
}
